import { EMPTY_CONTENT_HYPHEN } from '@/components/typography/placeholders';
import { EntityKind } from '@/types/schema';
import * as diagnostics from '@/utils/diagnostics';

import { EntityType } from '../types/EntityType';
import {
  EntityDisplayName,
  getDisplayNameFromEntityType,
} from '../utils/getDisplayNameFromEntityType';
import { getEntityTypeFromEntityKind } from '../utils/getEntityTypeFromEntityKind';

function normalizeParam(param: string): EntityType {
  return param.toLowerCase() as EntityType;
}

export function stringToDisplayType(
  paramType: string
): EntityDisplayName | 'Entity' {
  const normalizedParamType = normalizeParam(paramType);
  const displayName = getDisplayNameFromEntityType(normalizedParamType);
  if (!displayName) {
    diagnostics.warn('unknown entity type', { entity: normalizedParamType });
  }
  return displayName ?? 'Entity';
}

export function entityKindToDisplayName(
  kind: EntityKind
): EntityDisplayName | typeof EMPTY_CONTENT_HYPHEN {
  try {
    const entityType = getEntityTypeFromEntityKind(kind);

    return getDisplayNameFromEntityType(entityType);
  } catch (e) {
    diagnostics.warn('unknown entity kind', { entity: kind });

    return EMPTY_CONTENT_HYPHEN;
  }
}
